import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=20b05a00&scoped=true"
import script from "./delivery.vue?vue&type=script&lang=js"
export * from "./delivery.vue?vue&type=script&lang=js"
import style0 from "./delivery.vue?vue&type=style&index=0&id=20b05a00&prod&lang=scss&scoped=true"
import style1 from "./delivery.vue?vue&type=style&index=1&id=20b05a00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b05a00",
  null
  
)

export default component.exports